import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { CreatorSection } from './components/CreatorSection';
import { SolutionSection } from './components/SolutionSection';
import { SocialProofSection } from './components/SocialProofSection';
import { CTASection } from './components/CTASection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { Footer } from './components/Footer';
import { StickyBanner } from './components/StickyBanner';
import { SocialProofToast } from './components/SocialProofToast';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-ice font-body selection:bg-gold/30 selection:text-navy-dark" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyBanner data-id="element-2" />
      <SocialProofToast data-id="element-3" />
      <main className="pt-12" data-id="element-4">
        <HeroSection data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <CreatorSection data-id="element-7" />
        <SolutionSection data-id="element-8" />
        <CTASection data-id="element-9" />
        <SocialProofSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <UrgencySection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}